/**
 * @file: ErpLoginStatus.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ErpLoginStatus {
  Online = 'online',
  Expired = 'expired',
  Error = 'error',
}

export const ErpLoginStatusValueSet = new Set([
  ErpLoginStatus.Online,
  ErpLoginStatus.Expired,
  ErpLoginStatus.Error,
]);
